<template>
  <div>
    <div class="title mb-4">{{$t('Competencies')}}</div>
    <UiLoader v-if="isLoading" />
    <template v-else>
      <VForm
        v-model="valid"
        ref="form"
        lazy-validation
      >
        <VSelect
          :label="$t('Pick a competency')"
          :items="valuationList"
          prepend-icon="mdi-flag-checkered"
          :item-text="isEng ? 'name_eng' : 'name'"
          :rules="[rules.required]"
          :disabled="isLoadingForm"
          @change="handleChangeValuation($event)"
        />
        <VTextarea
          v-model="formData.description"
          :label="`${$t('Description')} RU`"
          :disabled="isFieldDisabled"
          prepend-icon="mdi-comment"
          rows="5"
          no-resize
        />
        <VTextarea
          v-model="formData.description_eng"
          :label="`${$t('Description')} EN`"
          :disabled="isFieldDisabled"
          prepend-icon="mdi-comment"
          rows="5"
          no-resize
        />
        <VBtn
          color="primary"
          link
          :loading="isLoadingForm"
          @click="handleSave()"
        >
          {{ $t('Save') }}
        </VBtn>
      </VForm>
    </template>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import { useStore } from '@vueblocks/vue-use-vuex';
import { onMounted, computed, ref } from '@vue/composition-api';
import { TableService } from '@/common/api.service.js'
import UiLoader from '@/components/uikit/UiLoader/UiLoader.vue'

export default {
  components: {
    UiLoader,
  },
  props: {},
  data: () => ({
    isLoadingForm: false,
    valid: true,
    formData: [],
    rules: {
      required: (value) => !!value,
    },
  }),
  computed: {
    ...mapState({
      valuationList: (state) => state.estimate.dictionary.valuation,
    }),
    isFieldDisabled () {
      return !this.formData?.id || this.isLoadingForm
    },
  },
  methods: {
    handleChangeValuation (value) {
      const current = this.valuationList.find((i) => i.name === value)

      if (!current) {
        this.$store.commit('MSG_SET_ITEM', { text: 'Ошибка выбора из справочника', debug: true })
        return
      }

      this.formData = current
    },
    showSaveError () {
      this.$store.commit('MSG_SET_ITEM', { text: 'Ошибка сохранения в справочник Ценности', debug: true })
    },
    async handleSave () {
      if (!this.$refs.form.validate()) {
        return false
      }

      this.isLoadingForm = true

      const tableData = { object: 'dictionary_element', data: this.formData }

      try {
        const result = await TableService.edit(tableData)

        if (!result?.[1]?.data) {
          this.showSaveError()
        }
      } catch (error) {
        this.showSaveError()
      }

      this.isLoadingForm = false
    },
  },
  setup () {
    const { state, dispatch } = useStore();

    const isEng = computed(() => state.param.locale === 'en');
    const isLoading = ref(true)

    onMounted(async () => {
      await dispatch('APP_PULL_ESTIMATE_DICTIONARY');
      isLoading.value = false
    });

    return {
      isLoading,
      isEng,
    }
  },
}
</script>
